<template>
  <div>
    <v-container pa-0 fluid>
      <div class="insert-title">신청 내역 조회</div>
      <div class="insert-subtitle">
        입점 신청 내역 확인을 위해 신청 시
        <div class="mobile-space"></div>
        등록한 휴대전화번호 입력이 필요합니다.
      </div>
      <div class="insert-border"></div>
      <div class="insert-content-all">
        <div class="insert-content insert-content-after">
          <div class="insert-content-left">
            사업자등록번호<span style="color: #01caff">*</span>
          </div>
          <div class="insert-content-num-input">
            <v-text-field
              placeholder="000"
              outlined
              hide-details
              maxLength="3"
              v-model="shop_reg_no1"
              color="#01c9ff"
            ></v-text-field>
          </div>
          <div class="insert-content-hyphen">-</div>
          <div class="insert-content-num-input">
            <v-text-field
              placeholder="00"
              outlined
              hide-details
              maxLength="2"
              v-model="shop_reg_no2"
              color="#01c9ff"
            ></v-text-field>
          </div>
          <div class="insert-content-hyphen">-</div>
          <div class="insert-content-num-input">
            <v-text-field
              placeholder="00000"
              outlined
              hide-details
              maxLength="5"
              v-model="shop_reg_no3"
              color="#01c9ff"
            ></v-text-field>
          </div>
        </div>
        <div class="insert-content insert-content-other">
          <div class="insert-content-left">
            사업주 휴대전화번호<span style="color: #01caff">*</span>
          </div>
          <div class="insert-content-num-input">
            <v-select
              outlined
              :items="phone1"
              color="#01c9ff"
              v-model="ceo_phone1"
            ></v-select>
          </div>
          <div class="insert-content-hyphen">-</div>
          <div class="insert-content-num-input">
            <v-text-field
              placeholder="1234"
              outlined
              hide-details
              v-model="ceo_phone2"
              color="#01c9ff"
              maxLength="4"
            ></v-text-field>
          </div>
          <div class="insert-content-hyphen">-</div>
          <div class="insert-content-num-input">
            <v-text-field
              placeholder="5678"
              outlined
              hide-details
              maxLength="4"
              v-model="ceo_phone3"
              color="#01c9ff"
            ></v-text-field>
          </div>
        </div>
      </div>
      <div class="insert-btn-block" style="cursor: pointer">
        <div class="real-insert-btn" @click="goSelect">조회하기</div>
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      category: [
        "1인분",
        "치킨/찜닭",
        "중식",
        "분식",
        "한식",
        "피자",
        "족발/보쌈",
        "패스트푸드",
        "돈까스/일식",
        "도시락/죽",
        "카페/디저트",
        "아시안/양식",
        "야식",
        "반찬",
      ],
      phone1: ["010", "011", "016", "017", "018", "019"],
      dialog: false,
      shop_reg_no: null,
      shop_reg_no1: null,
      shop_reg_no2: null,
      shop_reg_no3: null,
      ceo_phone: null,
      ceo_phone1: "010",
      ceo_phone2: null,
      ceo_phone3: null,
    };
  },
  watch: {
    ceo_phone1(text) {
      this.$nextTick(() => {
        this.ceo_phone1 = text.replace(/[^0-9]/g, "");
        this.ceo_phone = `${this.ceo_phone1}${this.ceo_phone2}${this.ceo_phone3}`;
      });
    },
    ceo_phone2(text) {
      this.$nextTick(() => {
        this.ceo_phone2 = text.replace(/[^0-9]/g, "");
        this.ceo_phone = `${this.ceo_phone1}${this.ceo_phone2}${this.ceo_phone3}`;
      });
    },
    ceo_phone3(text) {
      this.$nextTick(() => {
        this.ceo_phone3 = text.replace(/[^0-9]/g, "");
        this.ceo_phone = `${this.ceo_phone1}${this.ceo_phone2}${this.ceo_phone3}`;
      });
    },
    shop_reg_no1(text) {
      if (text) {
        this.$nextTick(() => {
          this.shop_reg_no1 = text.replace(/[^0-9]/g, "");
          this.shop_reg_no = `${this.shop_reg_no1}${this.shop_reg_no2}${this.shop_reg_no3}`;
        });
      }
    },
    shop_reg_no2(text) {
      if (text) {
        this.$nextTick(() => {
          this.shop_reg_no2 = text.replace(/[^0-9]/g, "");
          this.shop_reg_no = `${this.shop_reg_no1}${this.shop_reg_no2}${this.shop_reg_no3}`;
        });
      }
    },
    shop_reg_no3(text) {
      if (text) {
        this.$nextTick(() => {
          this.shop_reg_no3 = text.replace(/[^0-9]/g, "");
          this.shop_reg_no = `${this.shop_reg_no1}${this.shop_reg_no2}${this.shop_reg_no3}`;
        });
      }
    },
  },
  methods: {
    goSelect() {
      if (this.ceo_phone && this.shop_reg_no) {
        this.$router.replace({
          name: "User_Info",
          query: { shop_reg_no: this.shop_reg_no, ceo_phone: this.ceo_phone },
        });
      } else {
        alert("내용을 입력해 주세요.");
      }
    },
  },
};
</script>

<style scoped>
div {
  font-family: "NotoSansKRMedium";
}

.v-text-field {
  border-radius: 0 !important;
}
.v-input--selection-controls {
  padding-top: 0;
}
.dialog-title {
  background-color: #01c9ff;
  color: #ffffff;
}

.insert-btn {
  cursor: pointer;
}
/*
##Device = Desktops
##Screen = 1281px to higher resolution desktops
##Device = 데스크탑
##Screen = 1281px 이상 해상도 데스크탑
*/

@media (min-width: 1281px) {
  .container {
    width: 1170px !important;
  }
  .insert-title {
    height: 59px;
    font-size: 40px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.48;
    letter-spacing: -0.8px;
    text-align: left;
    color: #333333;
    margin-top: 50px;
    margin-bottom: 8px;
  }
  .insert-subtitle {
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.32px;
    text-align: left;
    color: #333333;
    margin-bottom: 50px;
  }
  .insert-border {
    height: 1px;
    background-color: #333333;
  }

  .insert-content {
    width: 100%;
  }

  .insert-content-all {
    margin-top: 50px;
    width: 100%;
  }

  .insert-content-left {
    width: 184px;
    height: 29px;
    margin: 15px 30px 26px 0;
    font-family: "NotoSansKRMedium";
    font-size: 20px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.45;
    letter-spacing: -0.4px;
    text-align: left;
    color: #333333;
  }

  .insert-content-num-input {
    width: 240px;
    height: 60px;
  }

  .insert-content::after {
    display: block;
    content: "";
    clear: both;
  }

  .insert-content-left,
  .insert-content-num-input,
  .insert-content-hyphen,
  .insert-btn {
    float: left;
  }
  .insert-content-hyphen {
    margin: 17px 7px 16px;
  }

  .insert-content-other {
    margin-top: 30px;
  }

  .insert-btn {
    width: 160px;
    height: 56px;
    margin: 0 0 0 20px;
    padding: 14px 63px 17px;
    background-color: #333333;
    font-family: "NotoSansKRMedium";
    font-size: 18px;
    font-weight: 500;
    color: #ffffff;
  }

  .insert-btn-block {
    margin-top: 331px;
  }
  .real-insert-btn {
    float: right;
    width: 288px;
    height: 60px;
    margin: 26px 10px 60px;
    padding: 17px 16px;
    background-color: #01c9ff;
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.36px;
    text-align: center;
    color: #ffffff;
    text-decoration: none;
  }

  .real-insert-btn-back {
    background-color: #e6e6e6;
    color: #333333;
  }
  .mobile-space {
    display: none;
  }
}

/*
##Device = Laptops, Desktops
##Screen = B/w 1025px to 1280px
##Device = 랩탑, 데스크탑
##Screen = 1025px에서 1280px 사이
*/

@media (min-width: 768px) and (max-width: 1280px) {
  .container {
    width: 586px !important;
  }
  .insert-title {
    height: 59px;
    font-family: "NotoSansKRMedium";
    font-size: 40px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.48;
    letter-spacing: -0.8px;
    text-align: center;
    color: #333333;
    margin-top: 50px;
  }

  .insert-subtitle {
    text-align: center;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.32px;
    text-align: center;
    color: #333333;
    margin-top: 8px;
    margin-bottom: 50px;
  }
  .insert-border {
    height: 1px;
    background-color: #333333;
  }

  .insert-content {
    width: 100%;
  }

  .insert-content-all {
    margin-top: 50px;
    width: 100%;
  }

  .insert-content-left-space {
    display: none;
  }

  .insert-content-left {
    width: 586px;
    height: 29px;
    margin: 15px 30px 26px 0;
    font-family: "NotoSansKRMedium";
    font-size: 20px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.45;
    letter-spacing: -0.4px;
    text-align: left;
    color: #333333;
  }

  .insert-content-num-input {
    width: 130px;
    height: 60px;
  }

  .insert-content::after {
    display: block;
    content: "";
    clear: both;
  }

  .insert-content-left,
  .insert-content-num-input,
  .insert-content-hyphen,
  .insert-content-store-name-input,
  .insert-btn,
  .insert-content-code-input,
  .insert-content-store-addr-input,
  .insert-content-space,
  .insert-content-checkbox-block,
  .insert-content-rider-name-input {
    float: left;
  }
  .insert-content-hyphen {
    margin: 17px 7px 16px;
  }

  .insert-content-store-name-input {
    width: 586px;
    height: 60px;
  }

  .insert-content-store-addr-input {
    width: 430px;
    height: 60px;
  }

  .insert-content-other {
    margin-top: 30px;
  }

  .insert-btn {
    width: 136px;
    height: 56px;
    margin: 0 0 0 20px;
    padding: 14px 51px 17px;
    background-color: #333333;
    font-family: "NotoSansKRMedium";
    font-size: 18px;
    font-weight: 500;
    color: #ffffff;
  }

  .insert-check-btn {
    padding: 14px 16px;
  }

  .insert-addr-btn {
    padding: 14px 32px;
  }
  .insert-content-space {
    margin: 17px 10px 16px;
  }

  .insert-content-warn {
    font-family: "NotoSansKRMedium";
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: -0.28px;
    text-align: left;
    color: #01caff;
    margin-bottom: -30px;
  }

  .insert-btn-block {
    margin-top: 30px;
  }
  .real-insert-btn {
    float: right;
    width: 288px;
    height: 60px;
    margin: 26px 2px 60px;
    padding: 17px 16px;
    background-color: #01c9ff;
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.36px;
    text-align: center;
    color: #ffffff;
    text-decoration: none;
  }

  .real-insert-btn-back {
    background-color: #e6e6e6;
    color: #333333;
  }

  .insert-content-rider-name-input {
    width: 155px;
    margin-top: -16px;
    margin-left: -61px;
  }

  .insert-content-order-checkbox {
    margin-top: 0;
  }

  .insert-radio-group {
    display: inline;
  }

  .insert-radio-btn {
    width: 150px;
  }
  .insert-radio-btn-2 {
    margin-bottom: 42px;
  }
  .insert-content-code-input,
  .insert-content-store-addr-input-2,
  .insert-code-btn {
    margin-top: 6px;
  }
  .mobile-space {
    display: none;
  }
}

/*
##Device = Tablets, Ipads (portrait),
##Screen = B/w 768px to 1024px
##Device = 태블릿, 아이패드(세로),
##Screen = 768px에서 1024px 사이
*/

/* @media (min-width: 768px) and (max-width: 1024px) {
} */

/*
##Device = Tablets, Ipads (landscape)
##Screen = B/w 768px to 1024px
##Device = 태블릿, 아이패드(가로)
##Screen = 768px에서 1024px 사이
*/

/* @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
} */

/*
##Device = Low Resolution Tablets, Mobiles (Landscape)
##Screen = B/w 481px to 767px
##Device = 저해상도 태블릿, 모바일(가로)
##Screen = 481px에서 767px 사이
*/

@media (max-width: 767px) {
  .container {
    width: 324px !important;
  }
  .insert-title {
    font-family: "NotoSansKRMedium";
    font-size: 24px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.48px;
    text-align: center;
    color: #333333;
    margin-top: 40px;
  }

  .insert-subtitle {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: -0.28px;
    text-align: center;
    color: #333333;
    margin-top: 8px;
    margin-bottom: 40px;
  }
  .insert-border {
    height: 1px;
    background-color: #333333;
  }

  .insert-content {
    width: 100%;
  }

  .insert-content-all {
    margin-top: 30px;
    width: 100%;
  }

  .insert-content-left-space {
    display: none;
  }

  .insert-content-left {
    width: 586px;
    height: 29px;
    margin: 0 30px 16px 0;
    font-family: "NotoSansKRMedium";
    font-size: 16px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.32px;
    text-align: left;
    color: #333333;
  }

  .insert-content-num-input {
    width: 98px;
    height: 48px;
  }

  .insert-content::after {
    display: block;
    content: "";
    clear: both;
  }

  .insert-content-left,
  .insert-content-num-input,
  .insert-content-hyphen,
  .insert-content-store-name-input,
  .insert-btn,
  .insert-content-code-input,
  .insert-content-store-addr-input,
  .insert-content-space,
  .insert-content-checkbox-block,
  .insert-content-rider-name-input {
    float: left;
  }
  .insert-content-hyphen {
    margin: 17px 4px 16px;
  }

  .insert-content-store-name-input {
    width: 324px;
    height: 48px;
  }

  .insert-content-store-addr-input {
    width: 211px;
    height: 48px;
  }

  .insert-content-other {
    margin-top: 30px;
  }

  .insert-btn {
    width: 324px;
    height: 56px;
    margin-top: 9px;
    padding: 19px 51px 17px;
    background-color: #333333;
    font-family: "NotoSansKRMedium";
    font-size: 16px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.07;
    letter-spacing: -0.28px;
    text-align: center;
    color: #ffffff;
  }

  .insert-addr-btn {
    padding: 18px 20px;
    width: 102px;
    margin: 1px 0 0 10px;
    height: 54px;
    /* padding: 19px 34px 17px; */
  }
  .insert-content-space {
    display: none;
  }

  .insert-content-warn {
    font-family: "NotoSansKRMedium";
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: -0.28px;
    text-align: left;
    color: #01caff;
    margin-bottom: -12px;
    margin-top: 15px;
  }

  .insert-btn-block {
    margin-top: 30px;
  }
  .real-insert-btn {
    float: right;
    width: 324px;
    height: 60px;
    margin: 26px 2px 60px;
    padding: 17px 16px;
    background-color: #01c9ff;
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.36px;
    text-align: center;
    color: #ffffff;
    text-decoration: none;
  }

  .real-insert-btn-back {
    background-color: #e6e6e6;
    color: #333333;
  }

  .insert-content-rider-name-input {
    width: 155px;
    height: 48px;
    margin-top: -16px;
    margin-left: -61px;
  }

  .insert-content-order-checkbox {
    margin-top: 0;
  }

  .insert-radio-group {
    display: inline;
  }

  .insert-radio-btn {
    width: 150px;
  }
  .insert-radio-btn-2 {
    margin-bottom: 30px;
  }
  .insert-content-code-input {
    margin-top: 10px;
    width: 211px;
  }
  .insert-code-btn {
    width: 102px;
    margin: 11px 0 0 11px;
    height: 55px;
    padding: 19px 34px 17px;
  }
  .insert-content-store-addr-input-2 {
    width: 324px;
    margin-top: 10px;
  }
  .insert-radio-btn-1 {
    margin-bottom: 7px;
  }
  .insert-content-left-use {
    margin-top: -28px;
  }
  .insert-content-left-imp {
    margin-top: 8px;
  }
  .insert-content-select-list {
    width: 324px;
  }
  .insert-content-select-list-2 {
    margin-top: 13px;
  }
}

/*
##Device = Most of the Smartphones Mobiles (Portrait)
##Screen = B/w 320px to 479px
##Device = 대부분의 스마트폰 모바일 기기(세로)
##Screen = 320px에서 479px 사이
*/

/* @media (min-width: 320px) and (max-width: 480px) {
} */
</style>